// "Beat my score" challenge deep links. We pack the level/character/difficulty +
// target score into a compact base64url payload appended to the game URL (?c=...).
import { GAME_URL } from "@/lib/share";

function b64urlEncode(str) {
  return btoa(unescape(encodeURIComponent(str))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function b64urlDecode(str) {
  const s = str.replace(/-/g, "+").replace(/_/g, "/");
  return decodeURIComponent(escape(atob(s)));
}

// payload: { l: levelIndex, c: charId, d: diffId, s: score, n: name }
export function encodeChallenge({ levelIndex, charId, diffId, score, name }) {
  try {
    const json = JSON.stringify({ l: levelIndex, c: charId, d: diffId, s: score, n: (name || "").slice(0, 24) });
    return b64urlEncode(json);
  } catch (e) {
    return "";
  }
}

export function decodeChallenge(token) {
  try {
    const o = JSON.parse(b64urlDecode(token));
    if (typeof o.l !== "number" || !o.c) return null;
    return { levelIndex: o.l, charId: o.c, diffId: o.d || "normal", score: Number(o.s) || 0, name: o.n || "" };
  } catch (e) {
    return null;
  }
}

export function buildChallengeUrl(payload) {
  const tok = encodeChallenge(payload);
  return tok ? `${GAME_URL}/?c=${tok}` : GAME_URL;
}
